"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_SPORTS_CLUB_FILTERS = exports.CHART_GENDER_FILTERS = exports.CHART_COMPACT_FROM_SCHOOLS = exports.CHART_MAX_SCHOOLS = exports.chartDataMetric = exports.CHART_DEFAULT_DISPLAY_METRIC = exports.CHART_DISPLAY_METRICS = exports.CHART_FEATURE_STYLE = exports.CHART_FEATURE_ABBR = exports.CHART_FEATURE_KEYS = void 0;
/**
 * Fitness chart features in Gerald's display order. All are motor tests where
 * higher = better performance. BMI is intentionally NOT a chart feature
 * (agreed with Gerald Jarnig): it is shown separately as weight classes.
 */
exports.CHART_FEATURE_KEYS = [
    "6MR",
    "JS",
    "SLJ",
    "MBT",
    "PU",
    "VSR",
    "ABC",
    "4x10SHR",
];
/** Axis/legend abbreviations (language independent). */
exports.CHART_FEATURE_ABBR = {
    "6MR": "6MR",
    JS: "JS",
    SLJ: "SLJ",
    MBT: "MBT",
    PU: "PU",
    VSR: "VSR",
    ABC: "ABC",
    "4x10SHR": "4×10SHR",
};
/**
 * Line/bar colour and marker per feature (Okabe-Ito, from Gerald's example
 * PDFs). Used by the web charts and the PDF Ergebnisblatt.
 */
exports.CHART_FEATURE_STYLE = {
    "6MR": { color: "#0072B2", marker: "circle" },
    JS: { color: "#D55E00", marker: "triangle" },
    SLJ: { color: "#009E73", marker: "diamond" },
    MBT: { color: "#8064A2", marker: "triangleDown" },
    PU: { color: "#CC79A7", marker: "cross" },
    VSR: { color: "#A07800", marker: "square" },
    ABC: { color: "#56B4E9", marker: "circle" },
    "4x10SHR": { color: "#111111", marker: "triangleRight" },
};
exports.CHART_DISPLAY_METRICS = [
    "overview",
    "z",
    "gpfit",
];
exports.CHART_DEFAULT_DISPLAY_METRIC = "overview";
/** Values behind a display metric: "overview" uses the GPfit points. */
const chartDataMetric = (metric) => metric === "z" ? "z" : "gpfit";
exports.chartDataMetric = chartDataMetric;
/**
 * Schools that can be compared in the group chart (SUPER_ADMIN). 2-4 schools
 * are shown as panels side by side; from CHART_COMPACT_FROM_SCHOOLS on, as a
 * compact matrix (one row per school, one small bar per feature).
 */
exports.CHART_MAX_SCHOOLS = 20;
/** From this number of schools the comparison uses the compact matrix. */
exports.CHART_COMPACT_FROM_SCHOOLS = 5;
exports.CHART_GENDER_FILTERS = [
    "MALE",
    "FEMALE",
];
exports.CHART_SPORTS_CLUB_FILTERS = [
    "YES",
    "NO",
];
